/**
 * Owner: Haselton Baker Risk Group, LLC
 * Date: 2022-02-14
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import {
  CONCRETE_SHEAR_WALLS_LOAD_BEARING,
  MASONRY_SHEAR_WALLS_LOAD_BEARING,
  PERCENT_GLAZING,
  PERCENT_OF_PARTITIONS_ARE_FIRE_BRAKE,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import ComponentQuestionGroup from './ComponentQuestions.jsx';

const mapStateToProps = (state, ownProps) => {
  const { form } = ownProps;
  const {
    selectVisibleRootComponentQuestionSubGroupsByGroup,
    selectVisibleRootComponentQuestionsByGroupSubGroup,
    selectFormFieldVisibility,
  } = modelTypesByForm[form];

  const getSubGroups = selectVisibleRootComponentQuestionSubGroupsByGroup(state);
  const getQuestions = selectVisibleRootComponentQuestionsByGroupSubGroup(state);
  const showPercentGlazing = selectFormFieldVisibility(state)(PERCENT_GLAZING);
  const showPercentOfPartitionsAreFireBrake = selectFormFieldVisibility(state)(
    PERCENT_OF_PARTITIONS_ARE_FIRE_BRAKE
  );
  const showConcreteShearWallsLoadBearing = selectFormFieldVisibility(state)(
    CONCRETE_SHEAR_WALLS_LOAD_BEARING
  );
  const showMasonryShearWallsLoadBearing = selectFormFieldVisibility(state)(
    MASONRY_SHEAR_WALLS_LOAD_BEARING
  );

  return {
    getSubGroups,
    getQuestions,
    showPercentGlazing,
    showPercentOfPartitionsAreFireBrake,
    showConcreteShearWallsLoadBearing,
    showMasonryShearWallsLoadBearing,
  };
};

export default connect(mapStateToProps)(ComponentQuestionGroup);
